import { FC, ReactNode } from 'react';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ICSSColorVariable } from '../../../models/color.model';
import styles from './IconWrapper.module.scss';

// Add icon SVGs in the Icons file, and it will be available for use with the Icon component.

export type SizeKeys = keyof typeof sizeToCssClassesMap;

const sizeToCssClassesMap = {
  xxs: 'iconWrapper--xxs',
  xs: 'iconWrapper--xs',
  sm: 'iconWrapper--sm',
  md: 'iconWrapper--md',
  lg: 'iconWrapper--lg',
  xlg: 'iconWrapper--xlg',
  xxlg: 'iconWrapper--xxlg',
};

enum ClassNames {
  Root = 'root',
}

type ClassNamesProp = { [Property in ClassNames]?: string };

export type IconColorVariable = ICSSColorVariable | 'none';

export type IIconColor = {
  primary?: IconColorVariable;
  secondary?: IconColorVariable;
};

export type IIcon = {
  size?: SizeKeys;
  classes?: ClassNamesProp;
  children?: ReactNode;
  color?: IIconColor;
};

export const IconWrapper: FC<IIcon> = ({
  size = 'md',
  classes = { root: '' },
  children,
}: IIcon) => {
  return (
    <div className={`${styles[sizeToCssClassesMap[size]]} ${classes?.root}`}>
      {children}
    </div>
  );
};
